import { Factory } from '../../services/Factory';

namespace app.directives.authentication {

  export interface IShowIfScope extends ng.IScope {
  }

  export class ShowIf implements ng.IDirective {
    public restrict:string = 'A';
    public link:(scope: IShowIfScope, element:ng.IAugmentedJQuery) => void;
    public replace:boolean = false;
    public scope = {
      isAdmin: "=",
      hasPermission: "@",
      roles: "="
    };

    constructor(roleService: app.services.authentication.RoleService) {
      this.link = (scope: IShowIfScope, element:ng.IAugmentedJQuery) => {
        const hideShowElement = isAllowed => {
          if (isAllowed) {
            element.show();
          } else {
            element.hide();
          }
        };

        scope.$watch("roles", val => {
          if (val) {
            if (scope.isAdmin === true) {
              hideShowElement(roleService.isAdmin(val));
            } else {
              hideShowElement(roleService.hasPermission(val, scope.hasPermission));
            }
          }
        });
      }
    }
  }

  frontendApp.directive("iioShowIf", ["RoleService", Factory.Create(ShowIf)]);
}
